"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchViewStyled = void 0;
exports.SearchViewStyled = styled.div.attrs({ className: 'octo' }) `
&.octo {
  display: flex;
  flex-flow: column nowrap;
  gap: 1.5em;
  align-items: stretch;
  justify-content: flex-start;

  > h2 {
    font-weight: 600;

    > span {
      font-size: 1.5em;

      &:last-child {
        font-style: italic;
      }
    }
  }

  >.results {
    display: flex;
    flex-flow: column nowrap;
    gap: 1em;
    align-items: stretch;
    justify-content: stretch;

    > h3 {
      font-weight: 600;

      > span {
        font-size: 1.25em;
      }
    }

    > button.result {
      cursor: pointer;

      &:hover {
        font-weight: 600;
      }
    }
  }
}
`;
//# sourceMappingURL=SearchView.styled.js.map